var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurNetworkLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 848,
    height: 6,
    viewBox: "0 0 848 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.113249 3L3 5.88675L5.88675 3L3 0.113249L0.113249 3ZM847.887 3L845 0.113249L842.113 3L845 5.88675L847.887 3ZM3 3.5H845V2.5H3V3.5Z",
    fill: "#094E8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurNetworkLine);
export default __webpack_public_path__ + "static/media/ourNetworkLine.259c40d8fdd631bab9db68a3f607581a.svg";
export { ForwardRef as ReactComponent };